import { IncomingEventType } from '@thoughtspot/embed-util';
import { EventType } from './core/constants';
import {
    destroyHandlers,
    dispatchEvent,
    dispatchNonMemoEvent,
    onMessage,
} from './core/handlers';
import { createEventSubscriber, subscribe } from './core/subscribe';
import {
    getHostEventConfig,
    getParentOrigin,
    setHostEventConfig,
    setParentOrigin,
} from './core/utils';
import { initUiPassthroughEvent } from './ui-passthrough-interface';

export const init = () => {
    window.addEventListener('message', onMessage);
    initUiPassthroughEvent(IncomingEventType.UiPassthrough, subscribe);
    dispatchNonMemoEvent(EventType.EmbedListenerReady, {});
};

export const destroy = destroyHandlers;

export { subscribe, createEventSubscriber };
export { dispatchEvent, dispatchNonMemoEvent };
export {
    getHostEventConfig,
    getParentOrigin,
    setHostEventConfig,
    setParentOrigin,
};

export const EventBridgeService = {
    subscribe,
    createEventSubscriber,
    dispatchEvent,
    dispatchNonMemoEvent,
    init,
    destroy,
    getHostEventConfig,
    getParentOrigin,
    setHostEventConfig,
    setParentOrigin,
};

export default EventBridgeService;
